import React, { useState, useRef, useEffect, useContext } from "react";
import Papa from 'papaparse';

//custom imports
import styles from '../../../assets/stylesheets/pages/caller/roster.module.scss'
import Upload from "../../../uicomponents/upload/upload";
import ApiActions from "../../../actions/ApiActions";
import useApi from "../../../hooks/useApi";
import FutworkButton from "../../../uicomponents/button/Button";
import checkIsEmpty from "../../../helper/checkIsEmpty";
import handleErrorMessage from "../../../helper/handleErrorMessage";
import ShowResult from "./showResult";
import { BulkActionContext } from "./bulkActionContext";
import CSVSchema from "./csvSchema";

const AddBasePay = () => {
    const [file, setFile] = useState('')
    const [inputValue, setInputValue] = useState({
        fileData: ''
    })
    const [errorMsg, setErrorMsg] = useState({
        fileData: '',
        api_error: ''
    })
    const [successMsg, setSuccessMsg] = useState({
        data: '',
        msg: ''
    })

    const { CERTIFY_AGENT, circularProg, checkComplete, isComplete, setIsComplete } = useContext(BulkActionContext)

    const addUpdateBaseEarningApi = useApi(ApiActions.addUpdateBaseEarning)

    const { data, loading, error } = addUpdateBaseEarningApi || {}

    useEffect(() => {
        setErrorMsg({
            ...errorMsg,
            api_error: handleErrorMessage(error)
        })
    }, [error])

    useEffect(() => {
        if (loading == false && (data && data.data)) {
            setIsComplete(2)
            if (data && data.data && data.data.unprocessed && data.data.unprocessed.length > 0) {
                setSuccessMsg({
                    msg: `Failed to add earnings for ${data && data.data && data.data.unprocessed.length} agent${data.data.unprocessed.length > 1 ? `'s` : ''}`,
                    data: data && data.data, failed: true
                })
            } else {
                setSuccessMsg({ msg: `The earnings is updated for ${data && data.data && data.data.processed.length} agent${data.data.processed.length > 1 ? `'s` : ''}`, data: data && data.data })
                setTimeout(() => {
                    circularProg.current.classList.toggle(styles['load_complete'])
                    checkComplete.current.style.display = 'block'
                }, 1000);
            }
        }
    }, [loading, data])

    const resetData = () => {
        setErrorMsg({ fileData: '', api_error: '' })
        setInputValue({ fileData: '' })
        // setIsComplete(0)
        // circularProg.current.classList.toggle(styles['circle_loader'])
        // checkComplete.current.style.display = 'none'
    }

    //call the function on choose the file
    const changeHandler = (e) => {
        const file = e.target.files[0]
        if (file && file.name && file.name.match(/\.(csv)$/)) { //check if the attached file is csv
            if (e.target.files.length > 0) {
                setFile(file)
                Papa.parse(file, {
                    header: true,
                    complete: function (results) {
                        const sanitizedResult = results.data.map(obj => {
                            if (obj.earnings && obj.mobile) {
                                return obj
                            }
                        }).filter(Boolean)
                        setInputValue({
                            fileData: sanitizedResult
                        })
                    }
                }
                )
            }
            const temp = { ...errorMsg }
            temp.fileData = ''
            setErrorMsg(temp)
        } else {
            setFile('')
            const temp = { ...errorMsg }
            temp.fileData = 'Only a file with .csv extension can be uploaded'
            setErrorMsg(temp)
        }
    }

    //check if a file is attached
    const checkIfDataPresent = () => {
        const { fileData } = inputValue
        if (fileData) return false
        else return true
    }

    //validate the data  in csv
    const checkIfValid = (csvheaders) => {
        let validationErrors = {};
        const multipleMandatoryHeaders = []
        csvheaders && csvheaders.forEach(item => {
            if (item.toLowerCase() == 'earnings' || item.toLowerCase() == 'mobile') multipleMandatoryHeaders.push(item)
        });

        // Simple validation for empty fields
        for (const key in inputValue) {
            // if (key == 'wa_from' && (inputValue[key].length < 10 || !isNumeric(inputValue[key]))) {
            //     validationErrors[key] = 'Please enter a valid 10 digit mobile number'
            // }
            // if (key == 'fileData' && inputValue[key].length > 5000) {
            //     validationErrors[key] = 'Please make sure the CSV contains less than 5000 rows of data.'
            // }
            // if (key == 'fileData' && csvheaders.find(head => (head.toLowerCase() == 'earnings' && head.toLowerCase() == 'mobile')) == undefined) {
            //     // validationErrors[key] = 'Please ensure that the csv includes the earnings & mobile.'
            // }
            if (key == 'fileData' && multipleMandatoryHeaders && multipleMandatoryHeaders.length < 2) {
                validationErrors[key] = `Please ensure that the earnings & mobile is mentioned in the csv schema`
            }
        }
        if (Object.keys(validationErrors).length > 0) {
            setErrorMsg(validationErrors);
            return false;
        } else {
            return true
        }
    }

    //upload the csv with base pay for corresponding agents
    const triggerBulkSend = () => {
        const [first] = inputValue.fileData
        const body_vars = first ? Object.keys(first).map(item => item) : []
        if (checkIfValid(body_vars)) {
            // const payload = {
            //     wa_from: inputValue.wa_from.trim(),
            //     wa_template_id: inputValue.wa_template_id.trim(),
            //     wa_body_vars: body_vars,
            //     leadsAr: inputValue.fileData
            // }
            const formData = new FormData();
            // formData.append('teleprojectId', projectData.id);
            formData.append('file', file);
            addUpdateBaseEarningApi.request(formData)
            setIsComplete(1)
        }
    }

    const props = {
        resetData,
        errorMsg,
        loading,
        successMsg
    }
    return <div>
        <div className={styles.crud_box}>
            {isComplete <= 0 ? <div className={styles.crud_form}>
                <CSVSchema />
                <Upload placeholder='Select CSV file to upload' onChange={changeHandler} />
                {
                    errorMsg && errorMsg.fileData ? <span className={styles.csv_error}>{errorMsg.fileData}</span> : null
                }
            </div> : <ShowResult  {...props} />}
        </div>
        <div className={styles['text-center']}>
            <FutworkButton buttonStyle="primary--solid" buttonSize="medium"
                disabled={checkIfDataPresent()}
                onClick={triggerBulkSend}>SUBMIT</FutworkButton>
        </div>
    </div>
}

export default AddBasePay